import { IconButton } from "@fluentui/react";
import React from "react";

import { Text } from "../items/Text";
import { Stack } from "../layouts/stack/Stack";
import { Dropzone } from "../surfaces/Dropzone";

export type FromUploadFieldProps = {
    droppedFilePath: string | undefined;
    onDropFile: (file: File) => void;
    onRemoveFile: () => void;
    disabled?: boolean;
};

export const FormUploadField: React.FunctionComponent<FromUploadFieldProps> = ({
    droppedFilePath,
    onDropFile,
    onRemoveFile,
    disabled
}) => {
    return (
        <Stack>
            <Text variant="large">{"Upload"}</Text>
            {!droppedFilePath ? (
                <Dropzone onDrop={onDropFile} disabled={disabled ?? false} />
            ) : (
                <Stack horizontal={true}>
                    <Text>{droppedFilePath}</Text>
                    <IconButton iconProps={{ iconName: "Cancel" }} onClick={onRemoveFile} />
                </Stack>
            )}
        </Stack>
    );
};
